/* src/app/old-settings/email-integration/email-integration.component.scss */
.c-alert {
  position: fixed;
  top: 91px;
  left: 0;
  right: 0;
  width: fit-content;
  min-height: 40px;
  display: flex;
  align-items: stretch;
  border-radius: 2px;
  font-size: 12px;
  z-index: 999999;
  border: 1px solid transparent;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.c-alert__icon {
  display: flex;
  align-items: center;
  padding: 6px 13px;
  font-size: 22px;
  color: #fff;
  font-weight: normal;
  flex-shrink: 0;
}
.c-alert__msg {
  display: flex;
  align-items: center;
  padding: 0 12px;
  color: #fff;
  font-size: 12px;
}
.c-alert__close {
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  color: inherit;
  font-size: 20px;
  padding: 0 10px;
  cursor: pointer;
  opacity: 0.65;
  line-height: 1;
  flex-shrink: 0;
  align-self: stretch;
}
.c-alert__close:hover {
  opacity: 1;
}
.c-alert--success {
  background-color: #4ac98e;
  border-color: #c3e6cb;
}
.c-alert--success .c-alert__icon {
  background: #18b06a;
}
.c-alert--success .c-alert__close {
  color: #fff;
}
.c-alert--danger {
  background-color: #e94f58;
  border-color: #e94f58;
}
.c-alert--danger .c-alert__icon {
  background: #dd1d28;
}
.c-alert--danger .c-alert__close {
  color: #fff;
}
.c-alert--warning {
  background-color: #fffbe6;
  border-color: #ffe58f;
}
.c-alert--warning .c-alert__msg {
  color: #484b59;
}
.c-alert--warning .c-alert__close {
  color: #484b59;
}
.c-alert--info {
  position: relative;
  top: unset;
  left: unset;
  right: unset;
  width: 100%;
  min-height: unset;
  box-shadow: none;
  background-color: #e8f4fd;
  border-color: #bee5eb;
}
.c-alert--info .c-alert__msg {
  color: #0c5460;
  padding: 10px 16px;
}
/*# sourceMappingURL=email-integration.component-MYGYL3XA.css.map */
